<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">


    <!--Datum zbirnog dnevnika dinarske blagajne-->

    <div class="form-group row">
      <div class="col-md-12">
        <yt-fw-date-picker-popup 
          formControlName="Datum" 
          name="txtDatum" 
          [Label]="'ZBIRNIDNEVNIK.DATUM.SINGULAR'"
          (OnDateSelected)='onDatumChange($event)'>
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
          <span *ngFor="let validation of errorMessages.Datum">
            <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.Datum.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>

    <!--Ulaz, POČETNO STANJE-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        1)
        <span translate="ZBIRNIDNEVNIK.UPS.SINGULAR"></span>
      </label>
      <div class="col-md-3">
         <yt-number-input-v2
        formControlName="UPs"
        name="txtUPs">
         </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input with=100% class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ulaz dinara sa računa-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        2)
        <span translate="ZBIRNIDNEVNIK.UUlDinSaRacuna.SINGULAR"></span>
      </label>
      <div class="col-md-3">       
        <yt-number-input-v2
        formControlName="UUlDinSaRacuna"
        name="txtUUlDinSaRacuna">
         </yt-number-input-v2>
      </div>      
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ulaz dinara isplaćenih na blagajni banke-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        3)
        <span translate="ZBIRNIDNEVNIK.UUlDinIsplNaBlagajni.SINGULAR"></span>
      </label>
      <div class="col-md-3">      
         <yt-number-input-v2
         formControlName="UUlDinIsplNaBlagajni"
         name="txtUUlDinIsplNaBlagajni">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Interni ulaz dinara sa drugog blagajničkog mesta-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        4)
        <span translate="ZBIRNIDNEVNIK.UIntUlSaDrBlagMesta.SINGULAR"></span>
      </label>
      <div class="col-md-3">       
         <yt-number-input-v2
         formControlName="UIntUlSaDrBlagMesta"
         name="txtUIntUlSaDrBlagMesta">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Interni ulaz dinara sa drugog menjačkog mesta-->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        5)
        <span translate="ZBIRNIDNEVNIK.UIntUlSaDrMenjMesta.SINGULAR"></span>
      </label>
      <div class="col-md-3">       
         <yt-number-input-v2
         formControlName="UIntUlSaDrMenjMesta"
         name="txtUIntUlSaDrMenjMesta">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>

     <!--Interni ulaz dinara na ime pružanja platnih usluga-->
     <div class="form-group row mt-0 mb-0" *ngIf="false">
      <label class="col-form-label col-6">
        5a)
        <span translate="ZBIRNIDNEVNIK.IULDINPLATUSL.SINGULAR"></span>
      </label>
      <div class="col-md-3">       
         <yt-number-input-v2
         formControlName="IUlDinPlatUsl"
         name="txtIUlDinPlatUsl">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>

    <!--Interni ulaz dinara u blagajnu po osnovu pružanja platnih usluga-->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        6)
        <span translate="ZBIRNIDNEVNIK.UIntUlUBlagPlatneUsluge.SINGULAR"></span>
      </label>
      <div class="col-md-3">       
         <yt-number-input-v2
         formControlName="UIntUlUBlagPlatneUsluge"
         name="txtUIntUlUBlagPlatneUsluge">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno uplate po osnovu prodaje efektive-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        7)
        <span translate="ZBIRNIDNEVNIK.UUkUplProdajaEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">     
         <yt-number-input-v2
         formControlName="UUkUplProdajaEfektive"
         name="txtUUkUplProdajaEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ulaz dinara sa bankomata-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        8)
        <span translate="ZBIRNIDNEVNIK.UUlDinSaBankomata.SINGULAR"></span>
      </label>
      <div class="col-md-3">      
         <yt-number-input-v2
         formControlName="UUlDinSaBankomata"
         name="txtUUlDinSaBankomata">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ulaz dinara sa privremenog blagajničkog mesta-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        9)
        <span translate="ZBIRNIDNEVNIK.UUlDinSaPrivrBlagMesta.SINGULAR"></span>
      </label>
      <div class="col-md-3">      
         <yt-number-input-v2
         formControlName="UUlDinSaPrivrBlagMesta"
         name="txtUUlDinSaPrivrBlagMesta">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ulaz dinara od putujućeg menjača-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        10)
        <span translate="ZBIRNIDNEVNIK.UUlDinOdPutMenjaca.SINGULAR"></span>
      </label>
      <div class="col-md-3">   
         <yt-number-input-v2
         formControlName="UUlDinOdPutMenjaca"
         name="txtUUlDinOdPutMenjaca">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu prodaje efektive-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        11)
        <span translate="ZBIRNIDNEVNIK.UUnpProdajaEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">  
         <yt-number-input-v2
         formControlName="UUnpProdajaEfektive"
         name="txtUUnpProdajaEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena providzija po osnovu otkupa efetive-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-6">
        12)
        <span translate="ZBIRNIDNEVNIK.UUnpOtkupEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="UUnpOtkupEfektive"
         name="txtUUnpOtkupEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu otkupa IN valuta-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        13)
        <span translate="ZBIRNIDNEVNIK.UUnpOtkupInValuta.SINGULAR"></span>
      </label>
      <div class="col-md-3">   
         <yt-number-input-v2
         formControlName="UUnpOtkupInValuta"
         name="txtUUnpOtkupInValuta">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu otkupa oštćene efektive-->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        14)
        <span translate="ZBIRNIDNEVNIK.UUnpOtkupOsteceneEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">  
         <yt-number-input-v2
         formControlName="UUnpOtkupOsteceneEfektive"
         name="txtUUnpOtkupOsteceneEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu otkupa vanopticajne vefektive-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        15)
        <span translate="ZBIRNIDNEVNIK.UUnpOtkupVanoptEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="UUnpOtkupVanoptEfektive"
         name="txtUUnpOtkupVanoptEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu zamene oštećene efektive-->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        16)
        <span translate="ZBIRNIDNEVNIK.UUnpZamenaOsteceneEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="UUnpZamenaOsteceneEfektive"
         name="txtUUnpZamenaOsteceneEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Ukupno naplaćena provizija po osnovu zamene vanopticajne efektive-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        17)
        <span translate="ZBIRNIDNEVNIK.UUnpZamenaVanoptEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="UUnpZamenaVanoptEfektive"
         name="txtUUnpZamenaVanoptEfektive">
          </yt-number-input-v2>
      </div>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
    </div>


    <!--Interni izlaz dinara na drugo blagajničko mesto-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        18)
        <span translate="ZBIRNIDNEVNIK.IIntIzNaDrBlagMesto.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IIntIzNaDrBlagMesto"
         name="txtIIntIzNaDrBlagMesto">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Interni izlaz dinara dianra na drugo menjačko mesto-->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        19)
        <span translate="ZBIRNIDNEVNIK.IIntIzNaDrMenjMesto.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IIntIzNaDrMenjMesto"
         name="txtIIntIzNaDrMenjMesto">
          </yt-number-input-v2>
      </div>
    </div>

    <!--Interni izlaz dinara na ime pružanja platnih usluga-->
    <div class="form-group row mt-0 mb-0" *ngIf="false">
      <label class="col-form-label col-md-6 pr-0">
        19a)
        <span translate="ZBIRNIDNEVNIK.IIZDINPLATUSL.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IIzDinPlatUsl"
         name="IIzDinPlatUsl">
          </yt-number-input-v2>
      </div>
    </div>

    <!--Interni izlaz dinara iz blagajne radi pružanja platnih usluga-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        20)
        <span translate="ZBIRNIDNEVNIK.IIntIzPlatneUsluge.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3"> 
         <yt-number-input-v2
         formControlName="IIntIzPlatneUsluge"
         name="txtIIntIzPlatneUsluge">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Ukupno isplate po osnovu otkupa efektive i čekovaa-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        21)
        <span translate="ZBIRNIDNEVNIK.IUkupnoOtkupEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IUkupnoOtkupEfektive"
         name="txtIUkupnoOtkupEfektive">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara na bankomat-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        22)
        <span translate="ZBIRNIDNEVNIK.IBankomat.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">   
         <yt-number-input-v2
         formControlName="IBankomat"
         name="txtIBankomat">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara na privremeno blagajničko mesto-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        23)
        <span translate="ZBIRNIDNEVNIK.IPrivrBlagMesto.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IPrivrBlagMesto"
         name="txtIPrivrBlagMesto">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara putujećem menjaču-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        24)
        <span translate="ZBIRNIDNEVNIK.IPutMenjacu.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3"> 
         <yt-number-input-v2
         formControlName="IPutMenjacu"
         name="txtIPutMenjacu">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara radi kupovine efektive od banke-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        25)
        <span translate="ZBIRNIDNEVNIK.IRadiKupovineEfektive.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3"> 
         <yt-number-input-v2
         formControlName="IRadiKupovineEfektive"
         name="txtIRadiKupovineEfektive">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara na osnovu uplate na tekući račun-->

    <div class="form-group row mt-0 mb-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        26)
        <span translate="ZBIRNIDNEVNIK.IUplataNaTekRacun.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">      
         <yt-number-input-v2
         formControlName="IUplataNaTekRacun"
         name="txtIUplataNaTekRacun">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara po osnovu isknjižavanja provizije-->

    <div class="form-group row mt-0 mb-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        27)
        <span translate="ZBIRNIDNEVNIK.IIsknjizavanjeProvizije.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IIsknjizavanjeProvizije"
         name="txtIIsknjizavanjeProvizije">
          </yt-number-input-v2>
      </div>
    </div>


    <!--Izlaz dinara po osnovu kursne razlike-->

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        28)
        <span translate="ZBIRNIDNEVNIK.IKursneRazlike.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <input class='form-control text-right' type="number" disabled />
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="IKursneRazlike"
         name="txtIKursneRazlike">
         </yt-number-input-v2>
      </div>
    </div>
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        <span translate="ZBIRNIDNEVNIK.Ukupno.SINGULAR"></span>
      </label>
      <label class="col-md-3 text-right pr-4">
        {{ukupnoUlaz | number : '1.2-2' : userService.GetLocaleString() }}
      </label>
      <label class="col-md-3 text-right pr-4">
        {{ukupnoIzlaz | number : '1.2-2' : userService.GetLocaleString() }}
      </label>
    </div>
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        29)
        <span translate="ZBIRNIDNEVNIK.StanjeBlagajneNaDan.SINGULAR"></span>
      </label>
      <label class="col-md-3">
      </label>
      <label class="col-md-3 text-right pr-4">
        {{ukupnoRazlika | number : '1.2-2' : userService.GetLocaleString() }}
      </label>
    </div>
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-6 pr-0">
        <span translate="ZBIRNIDNEVNIK.BRTRANS.PLURAL"></span>
      </label>
      <div class="col-md-3">
      </div>
      <div class="col-md-3">
         <yt-number-input-v2
         formControlName="BrTrans"
         name="txtBrTrans"
         [FormatString]="'1.0-0'"
         >
         </yt-number-input-v2>
      </div>
    </div>
  </div>

</form>